import { render } from "./achievementEvelution.vue?vue&type=template&id=133fed72&scoped=true"
import script from "./achievementEvelution.vue?vue&type=script&lang=js"
export * from "./achievementEvelution.vue?vue&type=script&lang=js"

import "./achievementEvelution.vue?vue&type=style&index=0&id=133fed72&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133fed72"]])

export default __exports__